const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export function getUserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'UTC';
  }
}

export async function verifyTicketStatusApi(data) {
  const url = new URL(`${apiBaseUrl}/user/payment/scan-ticket`);
  Object.entries({
    ...data,
    userTimezone: data.userTimezone ?? getUserTimezone(),
  }).forEach(([key, value]) => {
    if (value != null && value !== '') url.searchParams.set(key, value);
  });

  const response = await fetch(url.toString(), {
    headers: { 'Content-Type': 'application/json' },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.message || `Ticket check failed (${response.status})`);
    error.response = { data: payload, status: response.status };
    throw error;
  }
  return { data: payload };
}
